// Regex used to detect and strip the "Addon" prefix from service names.
// Service names prefixed with "Addon" (optionally separated by dashes,
// pipes, or em/en dashes) are treated as add-on services throughout the
// UI — they render in a separate <optgroup> and are sorted below
// primary services in practitioner cards.

export const ADDON_REGEX = /^\s*[-–—\s|]*Addon/i;
export const ADDON_CLEANUP_REGEX = /^\s*[-–—\s|]*Addon\s*[-–—\s|]*/i;
